


















import ChooseGroupItemLayout from './ChooseGroupItemLayout.vue';

export default {
    name: 'ChooseGroupItem',
    props: {
        filterGroup: {
            type: Object,
            required: true,
        },
        filter: {
            type: Object,
            required: true,
        },
    },
    components: {
        ChooseGroupItemLayout,
    },
    computed: {
        isChecked() {
            return this.$store.getters.isSelectedFilter(this.filter);
        },
    },
    methods: {
        handleCheckboxChange(e: Event) {
            this.$emit('change', e);
        },
    },
};
